export default __webpack_public_path__ + "static/media/important.44e60579.png";